// Auth utility functions

export const getUserDetails = () => {
  try {
    const userDetails = localStorage.getItem('userDetails');
    return userDetails ? JSON.parse(userDetails) : null;
  } catch (error) {
    console.error('Error parsing user details:', error);
    return null;
  }
};

export const getUserId = () => {
  const userDetails = getUserDetails();
  return userDetails?.id || null;
};

export const setUserDetails = (userData) => {
  localStorage.setItem('userDetails', JSON.stringify(userData));
};

export const clearUserDetails = () => {
  localStorage.removeItem('userDetails');
  // Clear Google account linking session flag
  sessionStorage.removeItem('google_account_linked');
};
